export default __webpack_public_path__ + "static/media/Bloodfen Mitts.c2ee4e19.jpg";